module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2fd9d2c7be81282708dc8e0951f8b221.png";